import React from 'react'
import Banner from '../../Components/Banner/Banner'
import ContactMe from '../../Components/ContactMe/ContactMe'
import Projects from '../../Components/Projects/Projects'
import facebook from '../../Assests/BsFacebook.png'
import insta from '../../Assests/BsInsta.png'
import linkedin from '../../Assests/BsLinkedIn.png'
import github from '../../Assests/BsGithub.png'
import Header from '../../Components/Header/Header'
import AboutMe from '../../Components/AboutMe/AboutMe'
import Footer from '../../Components/Footer/Footer'
import Skills from '../../Components/Skills/Skills'

export default function Home() {
    return (
        <div className=' relative'>
            <div className=' p-2  z-40 right-0 rounded-l top-1/2 fixed duration-500'>
                <a href="https://www.facebook.com/almahfuz97" target='_blank'><img src={facebook} alt="" className='mb-2 hover:shadow-md rounded-full w-10 shadow-md shadow-green-500 drop-shadow-lg h-10 hover:shadow-purple-400 cursor-pointer duration-200' /></a>
                <a href="https://www.linkedin.com/in/almahfuz" target='_blank'><img src={linkedin} alt="" className='mb-2 hover:shadow-md rounded-full w-10 shadow-md shadow-green-500 drop-shadow-lg h-10 hover:shadow-purple-400 cursor-pointer duration-200' /></a>
                <a href="https://www.github.com/almahfuz97" target='_blank'><img src={github} alt="" className='mb-2 hover:shadow-md rounded-full w-10 shadow-md shadow-green-500 drop-shadow-lg h-10 hover:shadow-purple-400 cursor-pointer duration-200' /></a>

            </div>
            <Header />
            <Banner />
            <Projects />
            <AboutMe />
            <Skills />
            <ContactMe />
            <Footer />
        </div>
    )
}
